import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/site";
import { Reveal } from "./Reveal";

export default function Faq() {
  return (
    <section id="faq" className="py-24 sm:py-32 bg-[#1B1B1B]" data-testid="faq-section">
      <div className="container-lux max-w-3xl">
        <Reveal className="mb-12">
          <p className="overline mb-3">FAQ</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            Questions, <span className="text-gold-metallic">answered.</span>
          </h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-white/10">
                <AccordionTrigger className="font-head uppercase tracking-tight text-lg text-left hover:text-[#D4AF37] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#C8C8C8] text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
